import { Formik } from "formik"
import AddServiceForm from "./AddServiceForm";
import { useObjectCard } from "../../context/ObjectCardProvider";
import * as apiObject from "api/apiObjects";
import { useSettings } from "context/SettingsContext";
import { useToast } from "context/ToastContext";
import { useTranslation } from "react-i18next";
import vconst from "utils/helpers/structs/vconst";

const initForm = {
    teamId      : null,
    serviceId   : null,
    isCustom    : true,
    name        : '',
    count       : 1,
    price       : 0,
    priceSale   : 0,
    description : ''
}

const AddServiceFormik = ({teamId, refFormik, setSubmittingFormik, setShowTeam, isOther = false}) =>{ 

    const { t } = useTranslation(['Objects']);
    const { showToast } = useToast();
    const { fetchObject } = useObjectCard();
    const { localSettings } = useSettings();
    const { objectId } = useObjectCard();
    const rate = localSettings?.RATE?.current || 1;

    return (
        <Formik 
            innerRef={refFormik}
            initialValues={{
                ...initForm,
                teamId : teamId,
                ...(isOther ? { expendTypeId: vconst.expendTypeDefExpend } : {}),
            }}
            onSubmit={async (values, {setSubmitting}) => {
                const count = Number(values.count);
                const price = Number(values.price);
                let priceSale = Number(values.priceSale);
                const name = String(values.name || '').trim();

                if (!(count > 0) || Number.isNaN(count)) {
                    return showToast(t('messErrorExpandCount'), 'danger');
                }
                if (values.price === '' || Number.isNaN(price) || price < 0) {
                    return showToast(t('messErrorExpandAmount'), 'danger');
                }
                if (values.isCustom && !name) {
                    return showToast(t('messErrorExpandName'), 'danger');
                }
                if (!values.isCustom && !values.serviceId && !name) {
                    return showToast(t('messErrorExpandService'), 'danger');
                }
                if (isOther && !values.expendTypeId) {
                    return showToast(t('messErrorExpandType'), 'danger');
                }

                // Якщо продаж не вказали — беремо собівартість (без live-синку в інпутах)
                if (values.priceSale === '' || Number.isNaN(priceSale) || priceSale === 0) {
                    priceSale = price;
                }

                setSubmittingFormik(true);
                const expendData = {
                    teamId: values.teamId || 0,
                    objectId,
                    serviceId: values.isCustom ? 0 : (values.serviceId || 0),
                    name,
                    count,
                    price,
                    priceRate: price * rate,
                    priceSale,
                    priceSaleRate: priceSale * rate,
                    description: values.description || '',
                    isOther: Boolean(isOther),
                    ...(isOther ? { expendTypeId: values.expendTypeId } : {}),
                }

                const resExpend = await apiObject.addExpendTeam(expendData);
                await fetchObject();
                setShowTeam(false);
                setSubmittingFormik(false);

                if (resExpend) showToast(t('messExpandAdd'), 'success')
                        else showToast(t('common:messError'), 'danger');

            }}>

            {({handleSubmit, isSubmitting, setFieldValue, values}) => (
                <AddServiceForm
                    titleAmount={t('addService.labelAmount')}
                    values={values}
                    isSubmitting={isSubmitting}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    showExpendType={isOther}/>
            )}

            
        </Formik>
    )
}

export default AddServiceFormik;
